<template>
  <div class="video-player-box">
    <div class="video-player-bg" v-show="bgIfShow">
      <img src="../../../../static/images/home/videobg.jpg" />
      <div class="video-player-play" @click="playClick">
        <img src="../../../../static/images/home/play.png" />
      </div>
    </div>
    <video-player v-show="!bgIfShow" ref="videoPlayer" :options="playerOptions" :playsinline="true"></video-player>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        playerOptions: {
          muted: false, //静音
          controls: false, //取消控制功能
          preload: 'auto', //自动加载
          loop: true, //循环播放
          autoplay: false, //自动播放
          fluid: true, //自动控制大小
          sources: [{
            type: "video/mp4",
            src: 'https://adsres.ftstats.com/web/guanwang/video/home.mp4'
          }]
        },
        bgIfShow: true
      }
    },
    methods: {
      playClick() {
        this.bgIfShow = false;
        this.$refs.videoPlayer.player.play();
      },
      videoSuspend() {
        this.bgIfShow = true;
        this.$refs.videoPlayer.player.pause();
      }
    }
  }
</script>
<style scoped lang="less">
  .video-player-box {
    width: 100%;

    .video-player-bg {
      width: 100%;
      position: relative;
      margin: -4px;

      img {
        width: 100%;
      }

      .video-player-play {
        width: 120px;
        height: 120px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 4;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/home/videoPart.vue